import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { Grid, Typography, Button } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import useWindowSize from '../../hooks/useWindowResize';
import { useLanguage } from '../../LanguageContext';

const SelectedImagesGallery = () => {
	const { $t } = useIntl();
	const { width } = useWindowSize();
	const swiperRef = useRef(null);
	const { locale } = useLanguage();

	const imageData = [
		'/assets/Images/AltynLogo.svg',
		'/assets/Images/company/rail/bridge-veresk.png',
		'/assets/Images/TrainStation.png',
		'/assets/Images/AirPlane.png',
		'/assets/Images/Ship.png',
		'/assets/Images/Train.png',
		'/assets/Images/RoadTruck.png',
	];

	return (
		<Grid
			overflow={"hidden"}
			display={'grid'}
			gap={'40px'}
			px={{ xs: '10px', xxs: '32px', md: '103px' }}
		>
			<Typography
				variant={'h2'}
				display={'flex'}
				justifyContent={'center'}
				fontSize={'25px'}
			>
				{$t({ id: 'selectedImageGalleryTitleMainPage' })}
			</Typography>
			<Grid
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
				gap={'20px'}
				width={{ xs: `${width - 30}px`, xxs: `${width - 90}px`, md: `${width - 230}px` }}
			>
				<Button
					style={{
						rotate: locale === 'fa' ? '180deg' : 0,
					}}
					onClick={() => swiperRef?.current?.swiper.slidePrev()}
				>
					<svg
						width="18"
						height="32"
						viewBox="0 0 18 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.8348 31.3271L0.728149 17.8692C0.485433 17.6199 0.302908 17.3328 0.180579 17.0078C0.0601917 16.6849 0 16.3489 0 16C0 15.6511 0.0601917 15.3141 0.180579 14.9892C0.302908 14.6662 0.485433 14.3801 0.728149 14.1308L13.8348 0.672897C14.2717 0.224299 14.7814 0 15.3639 0C15.9465 0 16.4562 0.224299 16.8931 0.672897C17.3299 1.1215 17.5484 1.64486 17.5484 2.24299C17.5484 2.84112 17.3299 3.36449 16.8931 3.81308L5.02423 16L16.8931 28.1869C17.3299 28.6355 17.5484 29.1589 17.5484 29.757C17.5484 30.3551 17.3299 30.8785 16.8931 31.3271C16.4562 31.7757 15.9465 32 15.3639 32C14.7814 32 14.2717 31.7757 13.8348 31.3271Z"
							fill="#444A5D"
						/>
					</svg>
				</Button>
				<Swiper
					slidesPerView={1}
					spaceBetween={100}
					navigation={true}
					className="selected-image-swiper"
					ref={swiperRef}
					style={{
						height: '300px',
					}}
					loop
					modules={[Autoplay]}
					autoplay={{
						delay: 2500,
						disableOnInteraction: false,
					}}
				>
					{imageData.map((image, index) => (
						<SwiperSlide key={index}>
							<Grid
								width={'100%'}
								height={'100%'}
								className="img-box"
								borderRadius={'10px'}
								overflow={'hidden'}
							>
								<img
									src={image}
									alt="Gallery"
									style={{
										objectFit: 'contain',
									}}
								/>
							</Grid>
						</SwiperSlide>
					))}
				</Swiper>
				<Button
					style={{
						rotate: locale !== 'fa' ? '180deg' : 0,
					}}
					onClick={() => swiperRef?.current?.swiper.slideNext()}
				>
					<svg
						width="18"
						height="32"
						viewBox="0 0 18 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13.8348 31.3271L0.728149 17.8692C0.485433 17.6199 0.302908 17.3328 0.180579 17.0078C0.0601917 16.6849 0 16.3489 0 16C0 15.6511 0.0601917 15.3141 0.180579 14.9892C0.302908 14.6662 0.485433 14.3801 0.728149 14.1308L13.8348 0.672897C14.2717 0.224299 14.7814 0 15.3639 0C15.9465 0 16.4562 0.224299 16.8931 0.672897C17.3299 1.1215 17.5484 1.64486 17.5484 2.24299C17.5484 2.84112 17.3299 3.36449 16.8931 3.81308L5.02423 16L16.8931 28.1869C17.3299 28.6355 17.5484 29.1589 17.5484 29.757C17.5484 30.3551 17.3299 30.8785 16.8931 31.3271C16.4562 31.7757 15.9465 32 15.3639 32C14.7814 32 14.2717 31.7757 13.8348 31.3271Z"
							fill="#444A5D"
						/>
					</svg>
				</Button>
			</Grid>
		</Grid>
	);
};

export default SelectedImagesGallery;
